var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarToggleExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5999 16.2998H18.4C17.1849 16.2998 16.2 17.2848 16.2 18.4998V29.4998C16.2 30.7148 17.1849 31.6998 18.4 31.6998H31.5999C32.815 31.6998 33.7999 30.7148 33.7999 29.4998V18.4998C33.7999 17.2848 32.815 16.2998 31.5999 16.2998Z",
    stroke: "#1B2559",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 16.2998V31.6998",
    stroke: "#1B2559",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21.7998L27.2 23.9998L25 26.1998",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarToggleExpand);
export default __webpack_public_path__ + "static/media/Sidebar-toggle-expand.4ea604569f1c23e3db1069cf310688b8.svg";
export { ForwardRef as ReactComponent };